import React, { useState, useEffect } from 'react';
import FormSection from 'components/sales/formSection/formSection';
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import Regex from 'services/utils/regex/Regex';
import localization from 'assets/localization/localization';

const RestaurantDetails = ({ data, handleValue }) => {
  const restaurantDetails = {
    noOfRestaurantsChain: '',
    weekendOccupancy: '',
    weekdayOccupancy: '',
  };

  const [restaurantData, setRestaurantData] = useState(restaurantDetails);
  const [weekend, setWeekend] = useState(data);
  const [weekday, setWeekday] = useState(data);
  useEffect(() => {
    if (data) {
      setWeekday(data.weekdayOccupancy);
      setWeekend(data.weekendOccupancy);
    }
  }, [data]);

  const handleFormData = async () => {
    if (restaurantData.noOfRestaurantsChain !== '') {
      let occupancy = [
        {
          weekday: restaurantData.weekendOccupancy,
          weekend: restaurantData.weekendOccupancy,
        },
      ];

      let restaurant_site_type_data = [
        {
          no_of_restaurants: restaurantData.noOfRestaurantsChain,
        },
      ];
      await handleValue({
        restaurant_site_type_data: restaurant_site_type_data,
        occupancy: occupancy,
      });
    } else handleValue(null);
  };

  useEffect(() => {
    handleFormData();
  }, [restaurantData]);

  return (
    <FormSection title={localization.restaurantDetailsTitle}>
      <ConstantInput
        label={localization.noOfRestaurantsChain}
        regex={Regex.numeric.test(restaurantData.noOfRestaurantsChain)}
        errorMsg={
          restaurantData.noOfRestaurantsChain
            ? localization.numericErrorMg
            : localization.requiredResturantinChain
        }
        type="text"
        handleChange={(val) => {
          setRestaurantData({
            ...restaurantData,
            noOfRestaurantsChain: val,
          });
        }}
        required
        isStarRequired={true}
      />

      <DropDownInput
        label={localization.weekdayOccupancy}
        data={data && data.weekdayOccupancy}
        required={false}
        getIdValue={(val) =>
          setRestaurantData({ ...restaurantData, weekdayOccupancy: val.value })
        }
      />
      <DropDownInput
        label={localization.weekendOccupancy}
        data={data && data.weekendOccupancy}
        required={false}
        getIdValue={(val) =>
          setRestaurantData({ ...restaurantData, weekendOccupancy: val.value })
        }
      />
    </FormSection>
  );
};
export default RestaurantDetails;
